<template>
    <div class="address-div">
        <div class="row">
            <div class="col">
                <text-field :required="required" placeholder="Address Line 1" class="form-control" v-on:filled-out="filledOut('street1', $event)" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <text-field placeholder="Address Line 2" class="form-control" v-on:filled-out="filledOut('street2', $event)" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <text-field :required="required" placeholder="City" class="form-control" v-on:filled-out="filledOut('city', $event)" />
            </div>
            <div class="col">
                <text-field :required="required" placeholder="State" class="form-control" v-on:filled-out="filledOut('state', $event)" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <text-field :required="required" placeholder="ZIP" class="form-control" v-on:filled-out="filledOut('zip', $event)" />
            </div>
            <div class="col">
                <text-field placeholder="Country" class="form-control" v-on:filled-out="filledOut('country', $event)" />
            </div>
        </div>
    </div>
</template>


<script>
import TextField from './TextField.vue';

export default {
    props: {
        placeholder: '',
        class: '',
        required: false,
    },
    data() {
        return {
            addressParts: {
                street1: '',
                street2: '',
                city: '',
                state: '',
                zip: '',
                country: ''
            },
        };
    },
    components: {
        TextField
    },
    methods: {
        filledOut: function (fieldId, fieldValue) {
            this.addressParts[fieldId] = fieldValue;
            this.$emit('filled-out', this.addressParts);
        }
    }
};
</script>

<style>
.address-div {
    display: contents;
}
</style>